<template>
  <div>

    <TemplateBasic
    >
    </TemplateBasic>

  </div>
</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";

export default {
  name: "PageTest",
  components: {
    TemplateBasic,
    TemplateButton,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/PageTest.vue